/**
 * Strictly enforce snake_case for event names as per enterprise standards.
 */
export const AnalyticsEvents = {
    // Auth Events
    LOGIN_SUCCESS: "login_success",
    LOGIN_FAILURE: "login_failure",
    LOGOUT: "logout",
    PHONE_LOGIN_STARTED: "phone_login_started",
    OTP_SEND_SUCCESS: "otp_send_success",
    OTP_SEND_FAILURE: "otp_send_failure",
    OTP_VERIFIED: "otp_verified",
    OTP_RESENT: "otp_resent",
    MULTI_ACCOUNT_PROMPT_SHOWN: "multi_account_prompt_shown",
    SIGNUP_FLOW_REDIRECTED: "signup_flow_redirected",
    // Navigation Events
    SCREEN_VIEW: "screen_view",
    // Feature Specific: Courses
    COURSE_CARD_CLICKED: "course_card_clicked",
    COURSE_ENROLL_CLICKED: "course_enroll_clicked",
    // Feature Specific: Referral (Refer & Earn)
    REFERRAL_PAGE_VIEWED: "referral_page_viewed",
    REFERRAL_CODE_COPIED: "referral_code_copied",
    REFERRAL_FAQ_VIEWED: "referral_faq_viewed",
    REFERRAL_MY_REFERRALS_VIEWED: "referral_my_referrals_viewed",
    REFERRAL_SHARE_INITIATED: "referral_share_initiated",
    REFERRAL_REMINDER_SENT: "referral_reminder_sent",
    // Feature Specific: Contact Us
    CONTACT_US_SCREEN_VIEWED: "contact_us_screen_viewed",
    CONTACT_US_REASON_PICKER_OPENED: "contact_us_reason_picker_opened",
    CONTACT_US_REASON_SELECTED: "contact_us_reason_selected",
    CONTACT_US_FORM_SUBMIT_SUCCESS: "contact_us_form_submit_success",
    CONTACT_US_FORM_SUBMIT_FAILURE: "contact_us_form_submit_failure",
    CONTACT_US_SUCCESS_MODAL_DISMISSED: "contact_us_success_modal_dismissed",
    CONTACT_US_ERROR_MODAL_DISMISSED: "contact_us_error_modal_dismissed",
    CONTACT_US_COUNTRY_CODE_CHANGED: "contact_us_country_code_changed",
    // Feature Specific: Profile
    PROFILE_SCREEN_VIEWED: "profile_screen_viewed",
    PROFILE_EDIT_DETAILS_OPENED: "profile_edit_details_opened",
    PROFILE_CHANGE_PASSWORD_OPENED: "profile_change_password_opened",
    PROFILE_CHANGE_PASSWORD_PHONE_FLOW_OPENED: "profile_change_password_phone_flow_opened",
    PROFILE_DELETE_ACCOUNT_ENTRY: "profile_delete_account_entry",
    PROFILE_PHONE_CHANGE_RESULT_MODAL_VIEWED: "profile_phone_change_result_modal_viewed",
    // Feature Specific: Exam Taking
    EXAM_START: "exam_start",
    EXAM_START_FAILURE: "exam_start_failure",
    SAVE_STUDENT_ANSWER_SUCCESS: "save_student_answer_success",
    SAVE_STUDENT_ANSWER_FAILURE: "save_student_answer_failure",
    SUBMIT_EXAM_SUCCESS: "submit_exam_success",
    SUBMIT_EXAM_FAILURE: "submit_exam_failure",
    // Feature Specific: TestLMS API
    TEST_LMS_GET_STUDENT_TEST: "test_lms_get_student_test",
    TEST_LMS_UPDATE_TEST_ATTEMPT: "test_lms_update_test_attempt",
    TEST_LMS_UPDATE_TEST_FINISH: "test_lms_update_test_finish",
    // Feature Specific: Doubts
    DOUBTS_SCREEN_VIEWED: "doubts_screen_viewed",
    DOUBTS_FILTER_OPENED: "doubts_filter_opened",
    DOUBTS_FILTER_APPLIED: "doubts_filter_applied",
    DOUBTS_BOOKMARKS_MODE_CHANGED: "doubts_bookmarks_mode_changed",
    DOUBTS_BOOKMARK_TOGGLED: "doubts_bookmark_toggled",
    DOUBTS_THREAD_OPENED_FROM_LIST: "doubts_thread_opened_from_list",
    DOUBTS_QUESTION_CREATED: "doubts_question_created",
    DOUBTS_ASK_QUESTION_VIEWED: "doubts_ask_question_viewed",
    DOUBTS_SUBJECT_CONFIRMED: "doubts_subject_confirmed",
    DOUBTS_CHAT_OPENED: "doubts_chat_opened",
    DOUBTS_NEW_QUESTION_ENTRY_SELECTED: "doubts_new_question_entry_selected",
    // Feature Specific: Zoom live class marketing
    ZOOM_MARKETING_PROMPT_SHOWN: "zoom_marketing_prompt_shown",
    ZOOM_MARKETING_PROMPT_DISMISSED: "zoom_marketing_prompt_dismissed",
    ZOOM_MARKETING_CTA_CLICKED: "zoom_marketing_cta_clicked",
    ZOOM_MARKETING_MINI_PLAYER_EXPAND: "zoom_marketing_mini_player_expand",
    ZOOM_MARKETING_MINI_PLAYER_LEAVE: "zoom_marketing_mini_player_leave",
};
